import React from 'react';

// Framed card (handoff_app_design/README.md §4.1). Use for the one or two most important blocks
// per screen only — everything else is <Section> or <ListGroup>.
// No shadow (§4.1, A5) — a thin border reads as "defined block" on its own; a shadow under every
// card is one of the tells of templated AI design.
//
// Props:
//   accentSide — token name ('quality' | 'positive' | 'accent') for a 3px border-inline-start cue,
//                e.g. today's quality workout. Omit for a plain card.
//   as         — element/component to render (default 'div').
export default function Card({ accentSide, as: As = 'div', className = '', style, children, ...rest }) {
  return (
    <As
      className={`rounded-card p-[18px] bg-surface border border-border ${className}`}
      style={accentSide ? { borderInlineStart: `3px solid var(--${accentSide})`, ...style } : style}
      {...rest}
    >
      {children}
    </As>
  );
}
